import React from 'react';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';

const BrandAssurance = ({ fields, rendering }) => {
  return (
    <div className="vds-brand-assurance" data-testid={fields.testid?.value}>
      <div className="vds-brand-assurance__inner">
        <Text tag="h2" className="vds-brand-assurance__heading" field={fields.heading} />
        <ul className="vds-brand-assurance__list">
          <Placeholder name="brandassurance-images" rendering={rendering} />
        </ul>
      </div>
    </div>
  );
};

export default BrandAssurance;
